import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scope", "toolName", "onComplete"];
import { useToolAccess } from '../hooks/useToolAccess';
import ToolAccessModal from '../ToolAccessModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function withToolAccess(WrappedComponent) {
  function WithToolAccess(props) {
    const {
        scope,
        toolName,
        onComplete
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const toolAccess = useToolAccess({
      scope,
      toolName
    });
    const onSubmitRequest = data => {
      toolAccess.closeModal();
      if (onComplete) {
        onComplete(data);
      }
    };
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ToolAccessModal, {
        onClose: toolAccess.closeModal,
        onComplete: onSubmitRequest,
        scope: scope,
        show: toolAccess.modalOpen,
        toolAccess: toolAccess
      }), /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest, {
        scope: scope,
        toolAccess: toolAccess
      }))]
    });
  }
  return WithToolAccess;
}
export default withToolAccess;